import { useSelector } from 'react-redux'
import { RootState } from '@src/store/store'
import { Navigate } from 'react-router-dom'
type Props = {
  children: React.ReactNode
}

export default function AuthWrapper({ children }: Props) {
  const accountInfo = useSelector((state: RootState) => state.account.accountInfo)
  const isLoggedIn = accountInfo?.token

  if (!isLoggedIn) {
    return <Navigate to='/landing-page' />
  }

  return <>{children}</>
}
